import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CommunityEngagementService {

  url: string;

  constructor(private http: HttpClient,
    private configService: ConfigurationService) {
    this.url = this.configService.getConfig('userTractionUrl');
  }


  private handleError(error: any): Promise<any> {
    return Promise.reject(error);
  }

  getOwnerProfileDetails(componentId: any, componentType: any) {
    return this.http.get(`${this.url}` + `component/ownerProfile?componentType=${componentType}&componentId=${componentId}`);
  }

  followorUnfollowUser(userDetails: any) {
    return this.http.post(`${this.url}` + `activity/followOrUnfollow?followingUserId=${userDetails.followingUserId}&isFollowing=${userDetails.isFollowing}`, { action: userDetails.action });
  }

}
